import * as tslib_1 from "tslib";
import React, { useMemo, } from 'react';
import Tooltip from 'rc-tooltip';
import * as RcSlider from 'rc-slider';
import Slider from 'rc-slider';
import _ from 'lodash';
const { Range } = RcSlider;
const createSliderWithTooltip = RcSlider.createSliderWithTooltip;
const RangeTooltip = createSliderWithTooltip(Range);
const Handle = RcSlider.Handle;
export { Handle, RangeTooltip, Range, Slider };
const handle = props => {
    const { value, dragging, index } = props, restProps = tslib_1.__rest(props, ["value", "dragging", "index"]);
    return (React.createElement(Tooltip, { prefixCls: "rc-slider-tooltip", overlay: value, visible: dragging, placement: "top", key: index },
        React.createElement(Handle, Object.assign({ value: value }, restProps))));
};
export const CustomSlider = (_a) => {
    var { children, markers } = _a, rest = tslib_1.__rest(_a, ["children", "markers"]);
    const marks = useMemo(() => {
        if (markers) {
            return _.reduce(markers, (acc, m) => {
                const mLabel = _.isFunction(m.label) ? m.label(m) : m.label;
                return Object.assign({}, acc, { [m.value]: Object.assign({}, m, { label: mLabel }) });
            }, {});
        }
        return rest.marks;
    }, [markers, rest.marks]);
    return React.createElement(Slider, Object.assign({ handle: handle }, rest, { marks: marks }));
};
//# sourceMappingURL=Slider.js.map